@if (systemAndBreakActivityStore.filteredTiles().length) {
    <div class="tile-list" data-test="time-registration-activity-list">
        @for (tile of systemAndBreakActivityStore.filteredTiles() | groupTiles; track tile.id) {
            @if (isDividerTile(tile)) {
                <priva-title
                    size="md"
                    theme="onlightblue"
                    class="title"
                    iconClass="{{ tile.dividerIcon }}"
                    title="{{ tile.dividerText | translate }}"
                    data-test="tile-separator"
                />
            } @else {
                @if (tileListUtils.isTile(tile)) {
                    <app-tile
                        class="tile-list__item"
                        [tile]="tile"
                        (click)="onTileClick(tile)"
                        data-test="tile-list-item"
                    />
                }
            }
        }
    </div>
} @else {
    <priva-notification class="no-results-notification" data-test="no-results-notification"
        >{{ 'ERROR.TITLE.NO_RESULTS_FOUND' | translate }}
    </priva-notification>
}
